export default __webpack_public_path__ + "static/media/Campra Accredited - Green.482cd2ec.svg";